import { User } from 'types'
import { Action } from './type'
import { MyLabelId } from '../reducers/sourcingAnnotationCandidates'

export const REFRESH_SOURCING_ANNOTATION_CANDIDATES =
  'REFRESH_SOURCING_ANNOTATION_CANDIDATES'
export function refreshSourcingAnnotationCandidates() {
  return {
    type: REFRESH_SOURCING_ANNOTATION_CANDIDATES,
  }
}

export type SourcingAnnotationsAction = Action & {
  type:
    | 'SUCCESS_FETCH_SOURCING_ANNOTATIONS_CANDIDATES'
    | 'SUCCESS_UPDATE_COMPANY_MY_LABELS'
}

// API response type
export type SourcingAnnotationsCandidatesResponse = {
  sourcingRoutes: {
    id: number
    name: string
    showOrder: number
  }[]
  myLabels: {
    id: number
    name: string
  }[]
}

export const SUCCESS_FETCH_SOURCING_ANNOTATIONS_CANDIDATES =
  'SUCCESS_FETCH_SOURCING_ANNOTATIONS_CANDIDATES'
export function successFetchCandidates(
  candidatesResponse: SourcingAnnotationsCandidatesResponse
) {
  return {
    type: SUCCESS_FETCH_SOURCING_ANNOTATIONS_CANDIDATES,
    payload: candidatesResponse,
  }
}

export const CHANGE_SOURCING_ROUTE = 'CHANGE_SOURCING_ROUTE'
export function changeSourcingRoute(payload: {
  companyId: string
  sourcingRouteId: number
  sourcingRouteName: string
  user: User
}) {
  return {
    type: CHANGE_SOURCING_ROUTE,
    payload,
  }
}

export const DETOUCH_COMPANY_SOURCING_ROUTE = 'DETOUCH_COMPANY_SOURCING_ROUTE'
export function detouchCompanySourcingRoute(payload: {
  companyId: string
  user: User
}) {
  return {
    type: DETOUCH_COMPANY_SOURCING_ROUTE,
    payload,
  }
}

export const SUCCESS_DETOUCH_COMPANY_SOURCING_ROUTE =
  'SUCCESS_DETOUCH_COMPANY_SOURCING_ROUTE'
export function successDetouchCompanySourcingRoute(payload: {
  companyId: string
  user: User
}) {
  return {
    type: SUCCESS_DETOUCH_COMPANY_SOURCING_ROUTE,
    payload,
  }
}

export const SUCCESS_UPDATE_COMPANY_SOURCING_ROUTE =
  'SUCCESS_UPDATE_COMPANY_SOURCING_ROUTE'
export function sucessUpdateCompanySouringRoute(payload: {
  companyId: string
  sourcingRouteName: string
}) {
  return {
    type: SUCCESS_UPDATE_COMPANY_SOURCING_ROUTE,
    payload,
  }
}

export const CREATE_SOURCING_ROUTE = 'CREATE_SOURCING_ROUTE'
export function createSourcingRoute(payload: { sourcingRouteName: string }) {
  return {
    type: CREATE_SOURCING_ROUTE,
    payload,
  }
}

export const UPDATE_SOURCING_ROUTE = 'UPDATE_SOURCING_ROUTE'
export function updateSourcingRoute(payload: { id: number; name: string }) {
  return {
    type: UPDATE_SOURCING_ROUTE,
    payload,
  }
}
export const DELETE_SOURCING_ROUTE = 'DELETE_SOURCING_ROUTE'
export function deleteSourcingRoute(payload: { id: number }) {
  return {
    type: DELETE_SOURCING_ROUTE,
    payload,
  }
}

export const SUCCESS_UPDATE_SOURCING_ROUTE = 'SUCCESS_UPDATE_SOURCING_ROUTE'
export function successUpdateSourcingRoute(payload: {
  id: number
  name: string
}) {
  return {
    type: SUCCESS_UPDATE_SOURCING_ROUTE,
    payload,
  }
}

export const SUCCESS_DELETE_SOURCING_ROUTE = 'SUCCESS_DELETE_SOURCING_ROUTE'
export function successDeleteSourcingRoute(payload: { id: number }) {
  return {
    type: SUCCESS_DELETE_SOURCING_ROUTE,
    payload,
  }
}

export const ADD_COMPANY_MY_LABEL = 'ADD_COMPANY_MY_LABEL'
export function putCompanyMyLabel(payload: {
  companyId: string
  myLabelId: number
  user: User
}) {
  return { type: ADD_COMPANY_MY_LABEL, payload }
}

export const DELETE_COMPANY_MY_LABEL = 'DELETE_COMPANY_MY_LABEL'
export function deleteCompanyMyLabel(payload: {
  companyId: string
  myLabelId: number
  user: User
}) {
  return { type: DELETE_COMPANY_MY_LABEL, payload }
}

export const CREATE_MY_LABEL = 'CREATE_MY_LABEL'
export function createMyLabel(payload: { name: string }) {
  return { type: CREATE_MY_LABEL, payload }
}

export const UPDATE_MY_LABEL = 'UPDATE_MY_LABEL'
export function updateMyLabel(payload: { id: MyLabelId; name: string }) {
  return { type: UPDATE_MY_LABEL, payload }
}

export const DELETE_MY_LABEL = 'DELETE_MY_LABEL'
export function deleteMyLabel(payload: { id: MyLabelId }) {
  return { type: DELETE_MY_LABEL, payload }
}
